/* eslint-disable react/display-name,react-hooks/exhaustive-deps */
import { createElement, useEffect } from "react"
import type { FC, ReactElement } from "react"

import { type IAppState, useAppSelector } from "@/3514/store/app"
import { EModalId, type TModalDispatcher, useModalDispatcher } from "@/3514/store/modal"
import type { TEmptyRenderCallback } from "@/shared/types/functions"

function withReloadAppModal(MainComponent: FC): TEmptyRenderCallback {
    return (): ReactElement => {
        const { isVersionMismatched }: IAppState = useAppSelector()

        const { showModal }: TModalDispatcher = useModalDispatcher()

        useEffect((): void => {
            if (isVersionMismatched) showModal(EModalId.ReloadApp)
        }, [isVersionMismatched])

        return createElement(MainComponent)
    }
}

export { withReloadAppModal }
